module.exports = __webpack_public_path__ + "static/media/pin_icon_grey.72cf44ba.svg";